import React from "react";
import "../CSS/Home.css";
import Carousel from "react-bootstrap/Carousel";
import flag1 from "../Assets/flag1.png";
import flag2 from "../Assets/flag2.jfif";
import flag3 from "../Assets/flag3.png";
import flag4 from "../Assets/flag4.png";
import flag5 from "../Assets/flag5.jfif";

import apron from "../Assets/Apron/6.jpg";
import cushion from "../Assets/Cushion/6.jpg";
import curtain from "../Assets/Curtain/6.jpg";
import throws from "../Assets/Throws/1.jpg";
import tablecloth from "../Assets/TableCloth/6.jpg";
import napkin from "../Assets/Napkins/4.jpg";
import runner from "../Assets/Runner/7.jpg";
import placemat from "../Assets/Placemat/9.webp";
import beachcloth from "../Assets/BeachTowel/1.jpg";
import laundrybag from "../Assets/LaundryBags/1.jpg";
import kitchentowel from "../Assets/KitchenTowel/1.jpg";
import img1 from "../Assets/home/img1.jpg";
// import Carousel from "react-multi-carousel";

function Home() {
  // window.scrollTo(0, 0);

  return (
    <div className="home-main">
      <div className="home-head">
        <Carousel fade interval={2000} pause={false}>
          <Carousel.Item>
            <img
              className="d-block w-100 slide-img"
              src={img1}
              alt="First slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100 slide-img"
              src="https://img.freepik.com/free-photo/fast-fashion-vs-slow-sustainable-fashion_23-2149133927.jpg?w=1060&t=st=1680591314~exp=1680591914~hmac=7755364ecd89edaa9b073a60e1813e5fbc90f569e90081f32d482af4d43bbacf"
              alt="Second slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100 slide-img"
              src="https://img.freepik.com/free-photo/close-up-image-lot-coils-with-threads-sewing-workshop_613910-4427.jpg?w=1060&t=st=1680591275~exp=1680591875~hmac=5e83a8f9959508e1c6416ce642ad197cb459ddb7d1ef365d50b0d550cb1e00d5"
              alt="Third slide"
            />
          </Carousel.Item>
        </Carousel>
      </div>
      <div className="country-main">
        <div className="home-top-intro">
          <h3>Global impex</h3>
          <p>
            At Global Impex, we believe in maintaining Quality with Ethics. We
            value and trust our customers' value, and we attempt to uphold it by
            providing products of unrivalled quality, brought possible by
            sophisticated manufacturing facilities and rigorous checking and
            testing processes at all stages of production.We work together with
            you to create an unique design which reflects your style and meets
            your requirements. We recognise that our clients' requirements may
            alter, and we are always ready to be malleable and flexible. Our
            team of creators and experienced workers will make sure to it that
            your concept is achieved.
          </p>
        </div>
        <h3 className="country-title">Countries Serving</h3>
        <div className="country-flex">
          <div className="country-multi-carousel">
            <div className="country-card">
              <img src={flag1}></img>
            </div>
            <div className="country-card">
              <img src={flag2}></img>
            </div>
            <div className="country-card">
              <img src={flag3}></img>
            </div>
            <div className="country-card">
              <img src={flag4}></img>
            </div>
            <div className="country-card">
              <img src={flag5}></img>
            </div>
          </div>
        </div>
      </div>

      {/* Product Ranges */}
      <div className="product-body-section">
        <h3 className="product-title">Product Categories</h3>
        <div className="product-list-flex">
          <div className="product-main">
            <img src={apron} />
            <div className="product-caption">
              <h3>Apron</h3>
            </div>
          </div>
          <div className="product-main">
            <img src={cushion} />
            <div className="product-caption">
              <h3>Cushion</h3>
            </div>
          </div>
          <div className="product-main">
            <img src={curtain} />
            <div className="product-caption">
              <h3>Curtain</h3>
            </div>
          </div>
        </div>

        <div className="product-list-flex">
          <div className="product-main">
            <img src={throws} />
            <div className="product-caption">
              <h3>Throws</h3>
            </div>
          </div>
          <div className="product-main">
            <img src={tablecloth} />
            <div className="product-caption">
              <h3>Table Cloths</h3>
            </div>
          </div>
          <div className="product-main">
            <img src={napkin} />
            <div className="product-caption">
              <h3>Napkins</h3>
            </div>
          </div>
        </div>

        <div className="product-list-flex">
          <div className="product-main">
            <img src={runner} />
            <div className="product-caption">
              <h3>Runner</h3>
            </div>
          </div>
          <div className="product-main">
            <img src={placemat} />
            <div className="product-caption">
              <h3>Placemat</h3>
            </div>
          </div>
          <div className="product-main">
            <img src={beachcloth} />
            <div className="product-caption">
              <h3>Beach Towel</h3>
            </div>
          </div>
        </div>

        <div className="product-list-flex">
          <div className="product-main">
            <img src={laundrybag} />
            <div className="product-caption">
              <h3>Laundry Bags</h3>
            </div>
          </div>
          <div className="product-main">
            <img src={kitchentowel} />
            <div className="product-caption">
              <h3>Kitchen Towel</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Home;
